/* rewi-neo.js - REWI's layer on the aico landing page renderer.
 *
 * Loaded between content-builder-neo.js (the engine, window.NewsNeo) and
 * content-builder-neo-ext.js (the element types), both copied verbatim from
 * the Club theme. Neither is edited, so this file adjusts what the ext
 * registers: it wraps the ext's renderer for a type at the moment the ext
 * registers it, and the ext's own first paint already uses the wrapped one.
 *
 * FEATURES (the start page's trust bar). The ported renderer is older than
 * the aico builder and leaves out three things REWI's pages use:
 *   - the named tile icons (Package, Truck, Headphones, ...): it only draws an
 *     uploaded icon image, so a named icon was an empty frame;
 *   - «Darstellung» (grid / list / cards) and «Kacheln pro Reihe»: it always
 *     made one column per tile;
 *   - a tile's link.
 * The icons are the same 25 lucide shapes aico's own static renderer draws
 * (NeoLandingPageBodyRenderer::ICON_GEOMETRY), so the shop, the builder and
 * the no-JavaScript body show the same icon. The tile layout itself is REWI's
 * (assets/rewi-neo.css): icon beside the text, as the start page mock-up
 * draws the trust bar.
 */
(function (window) {
  'use strict';

  var Neo = window.NewsNeo;
  if (!Neo || typeof Neo.registerType !== 'function') return;

  var ICONS = {
    Award: '<path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"/><circle cx="12" cy="8" r="6"/>',
    BarChart3: '<path d="M3 3v16a2 2 0 0 0 2 2h16"/><path d="M18 17V9"/><path d="M13 17V5"/><path d="M8 17v-3"/>',
    Calendar: '<path d="M8 2v4"/><path d="M16 2v4"/><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M3 10h18"/>',
    Camera: '<path d="M13.997 4a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 1.759-1.048l.489-.904A2 2 0 0 1 10.004 4z"/><circle cx="12" cy="13" r="3"/>',
    Check: '<path d="M20 6 9 17l-5-5"/>',
    Clock: '<circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/>',
    Eye: '<path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"/><circle cx="12" cy="12" r="3"/>',
    Gift: '<path d="M12 7v14"/><path d="M20 11v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8"/><path d="M7.5 7a1 1 0 0 1 0-5A4.8 8 0 0 1 12 7a4.8 8 0 0 1 4.5-5 1 1 0 0 1 0 5"/><rect x="3" y="7" width="18" height="4" rx="1"/>',
    Globe: '<circle cx="12" cy="12" r="10"/><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"/><path d="M2 12h20"/>',
    Headphones: '<path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3"/>',
    Heart: '<path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"/>',
    Lock: '<rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>',
    Mail: '<path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"/><rect x="2" y="4" width="20" height="16" rx="2"/>',
    MapPin: '<path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"/><circle cx="12" cy="10" r="3"/>',
    Package: '<path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z"/><path d="M12 22V12"/><polyline points="3.29 7 12 12 20.71 7"/><path d="m7.5 4.27 9 5.15"/>',
    Phone: '<path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"/>',
    RefreshCw: '<path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/><path d="M8 16H3v5"/>',
    Shield: '<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/>',
    Star: '<path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"/>',
    ThumbsUp: '<path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"/><path d="M7 10v12"/>',
    Ticket: '<path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"/><path d="M13 5v2"/><path d="M13 17v2"/><path d="M13 11v2"/>',
    Trophy: '<path d="M10 14.66v1.626a2 2 0 0 1-.976 1.696A5 5 0 0 0 7 21.978"/><path d="M14 14.66v1.626a2 2 0 0 0 .976 1.696A5 5 0 0 1 17 21.978"/><path d="M18 9h1.5a1 1 0 0 0 0-5H18"/><path d="M4 22h16"/><path d="M6 9a6 6 0 0 0 12 0V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1z"/><path d="M6 9H4.5a1 1 0 0 1 0-5H6"/>',
    Truck: '<path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/>',
    Users: '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><path d="M16 3.128a4 4 0 0 1 0 7.744"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><circle cx="9" cy="7" r="4"/>',
    Zap: '<path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"/>'
  };

  var VARIANTS = { grid: true, list: true, cards: true };

  function svgFor(name) {
    var shape = ICONS[name];
    return shape
      ? '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor"' +
        ' stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + shape + '</svg>'
      : '';
  }

  /* Same rule as aico's renderer: http(s), a path, an anchor, mail and phone.
     Anything else leaves a plain tile rather than a dead or unsafe link. */
  function safeHref(url) {
    var v = String(url || '').trim();
    return /^(https?:\/\/|\/|#|mailto:|tel:)/i.test(v) ? v : '';
  }

  function escapeAttr(s) {
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }

  var ITEM_OPEN = '<div class="neo-features__item">';

  /* The ext's markup is a wrapper `<div class="content-type-neo-features" …>`
     with one ITEM_OPEN … `</div>` per tile, in item order, each holding an
     optional image, the icon frame, the title and the text. */
  function enhanceFeatures(render) {
    return function (el) {
      var html = render(el);
      var c = (el && el.content) || {};
      var items = Array.isArray(c.items) ? c.items : [];
      var variant = VARIANTS[c.layoutVariant] ? c.layoutVariant : 'grid';
      var columns = variant === 'list' ? 1 : (Number(c.columns) || 3);

      html = html.replace('class="content-type-neo-features"',
        'class="content-type-neo-features neo-features--' + variant + '" data-neo-cols="' + Math.max(1, Math.min(6, columns)) + '"');

      var parts = html.split(ITEM_OPEN);
      for (var i = 1; i < parts.length; i++) {
        var item = items[i - 1] || {};
        var part = parts[i];
        if (item.image) {
          /* A picture replaces the icon, as in the builder. */
          part = part.replace(/<div class="neo-features__icon"[^>]*><\/div>/, '');
        } else if (!item.iconUrl) {
          var frameStyle = c.featuresIconColor ? ' style="color:' + escapeAttr(c.featuresIconColor) + '"' : '';
          part = part.replace(/<div class="neo-features__icon"([^>]*)><\/div>/, function (m, attrs) {
            var svg = svgFor(item.icon || 'Zap');
            if (!svg) return '';
            if (frameStyle && /style="/.test(attrs)) {
              attrs = attrs.replace('style="', 'style="color:' + escapeAttr(c.featuresIconColor) + ';');
              frameStyle = '';
            }
            return '<div class="neo-features__icon"' + attrs + frameStyle + '>' + svg + '</div>';
          });
        }
        var tag = 'div';
        var open = ITEM_OPEN;
        var href = safeHref(item.link);
        if (href) {
          tag = 'a';
          open = '<a class="neo-features__item neo-features__item--link" href="' + escapeAttr(href) + '">';
          /* The tile's own closing tag is the last `</div>`, or for the last
             tile the one before the wrapper's. */
          var at = i === parts.length - 1 ? part.lastIndexOf('</div>', part.lastIndexOf('</div>') - 1) : part.lastIndexOf('</div>');
          if (at > -1) part = part.slice(0, at) + '</a>' + part.slice(at + 6);
        }
        parts[i] = (tag === 'a' ? open : ITEM_OPEN) + part;
      }
      return parts.join('');
    };
  }

  var register = Neo.registerType;
  Neo.registerType = function (type, fn) {
    if (type === 'features' && typeof fn === 'function') fn = enhanceFeatures(fn);
    return register.call(Neo, type, fn);
  };
})(window);
